import { getAllowedLocaleList } from '../app/bootstrap';


export const allowedLocaleList = getAllowedLocaleList();

export const localeDetails = (supportedLocales, locale) => {
    const fullySupportedLocales = supportedLocales;

    const supportedLocalesUniqueObj = {};
    let fullySupportedLocalesUniqueArr = [];

    const localeCountryCode = locale.split('-')[1];

    fullySupportedLocales.map((item) => {
        const countryCode = item.split('-')[1];

        if (!supportedLocalesUniqueObj[countryCode]) {
            supportedLocalesUniqueObj[countryCode] = countryCode === localeCountryCode ? locale : item;
        }
        return item;
    });

    fullySupportedLocalesUniqueArr = Object.values(supportedLocalesUniqueObj);

    const selectedCountryOnly = locale.split('-')[1];

    const localesForSelectedCountry = fullySupportedLocales.filter(
        (supportedLocale) => {
            if (supportedLocale.split('-')[1] === selectedCountryOnly) {
                return supportedLocale;
            }
            return false;
        }
    );

    return { fullySupportedLocalesUniqueArr, localesForSelectedCountry };
};
